import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persist-indexeddb";

import animation from './modules/animation';
import app from './modules/app';
import auth from './modules/auth';
import learningState from './modules/learningState';
import history from './modules/history';
import recorded from './modules/recorded';
import soundData from './modules/soundData';
import imageData from './modules/imageData';
import clearLog from './modules/clearLog';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    animation,
    app,
    auth,
    learningState,
    history,
    recorded,
    soundData,
    imageData,
    clearLog,
  },
  plugins: [
    createPersistedState({
      key: 'MultiplicationApp',
      paths: [
        'app.autoReleaseRemainingTime',
        'auth',
        'learningState',
        'history',
        'recorded',
        'soundData',
        'imageData',
        'clearLog',
      ],
    }),
  ],
})
